import CommonOperationClass from '../../../commonOperationClass';

const five = new CommonOperationClass('5');

export default five;
